<div class="d-flex gap-3 w-100 align-items-center justify-content-center analytics-group">
  <p [ngClass]="warningMessage !== '' ? '' : 'd-none'" class="text-para text-dark">{{ warningMessage }}</p>
  <div [ngClass]="warningMessage === '' ? '' : 'd-none'" class="w-50">
    <canvas id="donutChart"></canvas>
  </div>
  <div [ngClass]="warningMessage === '' ? '' : 'd-none'" class="w-50" id="legend"></div>
</div> 